import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../SellerProductDetails/SellerProductDetails.css";

import rating from "../../assets/Star.png";
import installement from "../../assets/installement.png";
import international from "../../assets/international.png";
import insta from "../../assets/insta.png";
import whatsapp from "../../assets/whatsapp.png";
import facebook from "../../assets/facebook.png";
import placeholder from "../../assets/placeholder.jpg";

import { BaseUrl } from "../../App";
import SellerServicesUrl from "../../SellerServicesUrl";

export default function SellerProductDetails() {
  const { id } = useParams();
  const [ad, setAd] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userRate, setUserRate] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .get(
        BaseUrl +
          SellerServicesUrl.GetProductById.replace("{id}", id),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        const data = res.data?.data.productDetails;
        setAd(data);
        if (data?.avg_rate) {
          setUserRate(Math.round(data.avg_rate));
        }
      })
      .catch((err) => console.log(err));
  }, [id]);

  // if (!ad) {
  //   return (
  //     <div className="text-center mt-5 pt-5">
  //       <h4>Loading...</h4>
  //     </div>
  //   );
  // }
if (!ad) {
  return (
    <div className="container mt-5 pt-5">
      <div className="order-skeleton-card">
        <div className="skeleton-lock"></div>

        <div className="skeleton-middle">
          <div className="skeleton-line short"></div>
          <div className="skeleton-line medium"></div>
        </div>

        <div className="skeleton-right">
          <div className="skeleton-badge"></div>
          <div className="skeleton-line small"></div>
        </div>
      </div>
    </div>
  );
}

  const images = ad.image || [];

  //  TOGGLE RATE
  const handleRate = async (rate) => {
    const newRate = userRate === rate ? 0 : rate;

    setUserRate(newRate);

    const token = localStorage.getItem("token");

    try {
      await axios.post(
        BaseUrl +
          SellerServicesUrl.RateProduct.replace("{id}", id),
        { rate: newRate },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      console.error("Rating error:", err);
    }
  };

  return (
//     <div className="dproduct-page mb-5 pb-5 container c">
//       <h1 className="product-heading dproduct-heading2">
//         تفاصيل الإعلان /{" "}
//         <span className="comm">{ad.categoryName}</span>
//       </h1>

//       <div className="product-wrapper">
//         {/* IMAGE */}
//         <div className="dproduct-image-box">
//           {images.length > 0 ? (
//             // <img
//             //   src={images[currentIndex]}
//             //   // alt={ad.name}
//             //   className="main-image2"
//             // />
//             <img
//   src={images[currentIndex] || "/placeholder.jpg"}
//   className="main-image2"
//   onError={(e) => {
//     e.target.src = "/placeholder.jpg";
//   }}
// />

//           ) : (
//             <div className="main-image2 d-flex align-items-center justify-content-center">
//               لا توجد صورة
//             </div>
//           )}
//         </div>

//         {/* INFO */}
//         <div className="product-info">
//           <div className="dtitle-rating-row">
//             <h2 className="dproduct-title">{ad.name}</h2>
//             <div className="drating-row">
//               {/* <img src={rating} alt="star" /> */}
//               <span className="drate-number">
//                 {ad.avg_rate?.toFixed(1) || 0}
//               </span>
//             </div>
//           </div>

//           <p className="product-desc2">{ad.description}</p>

//           <div className="dprice-row">
//             <span className="dcurrent-price">
//               {ad.priceAfterDiscount} {ad.currency_type}
//             </span>
//             <span className="dold-price">
//               {ad.price} {ad.currency_type}
//             </span>
//             <span className="ddiscount">
//               {ad.discount}%
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* SHIPPING */}
//       <div className="big-cart d-flex align-items-center">
//         <div className="first-cart">
//           <img src={international} alt="" />
//           <span className="text-white d-block">
//             {ad.delivery_type === "internal"
//               ? "شحن داخلي"
//               : "شحن دولي"}
//           </span>
//         </div>

//         {ad.is_installment === 1 && (
//           <div className="second-cart">
//             <img src={installement} alt="" />
//             <span className="text-white d-block">
//               تقسيط
//             </span>
//           </div>
//         )}
//       </div>

//       {/* STORE CARD */}
//       <div className="product-bottom-box mt-5 mb-5">
//         <div className="seller-box mt-4">
//           <div className="seller-info-wrap">
//             <img
//               src={
//                 ad.store_image || "/placeholder.jpg"
//               }
//               className="seller-img"
//               // alt="seller"
//             />
//             <div className="d-flex flex-column w-100">
//               <div className="seller-info mb-2">
//                 <h4 className="seller-name">
//                   {ad.store_name || "المتجر"}
//                 </h4>

//                 <div className="share-icons">
//                   {ad.linkFacebook && (
//                     <img src={facebook} alt="fb" />
//                   )}
//                   {ad.linkWhatsapp && (
//                     <img src={whatsapp} alt="wa" />
//                   )}
//                   {ad.linkInsta && (
//                     <img src={insta} alt="insta" />
//                   )}
//                 </div>
//               </div>

//               <p className="seller-location text-end">
//                 الحالة: {ad.status}
//               </p>
//             </div>
//           </div>
//         </div>

//         <hr className="divider" />

//         <h3 className="rate-title">
//           تقييمك للمنتج
//         </h3>

//         <div className="stars">
//           {[1, 2, 3, 4, 5].map((i) => (
//             <span
//               key={i}
//               onClick={() => handleRate(i)}
//               style={{
//                 fontSize: "28px",
//                 cursor: "pointer",
//                 margin: "0 6px",
//                 color:
//                   userRate >= i
//                     ? "#ffb300"
//                     : "#ccc",
//                 transition: "0.2s",
//               }}
//             >
//               ★
//             </span>
//           ))}
//         </div>

//         <p className="text-muted small mt-2">
//           إجمالي التقييمات:{" "}
//           {ad.total_rate || 0}
//         </p>
//       </div>
//     </div>
   <div className="dproduct-page mb-5 pb-5 container c">
      {/* ===== TITLE ===== */}
      {/* <h1 className="product-heading dproduct-heading2">
        تفاصيل الإعلان / <span className="comm">{ad.categoryName}</span>
      </h1> */}

      <div className="product-wrapper col-md-6">
        {/* ===== IMAGE ===== */}
        <div className="dproduct-image-box col-md-6">
          {images.length > 0 ? (
//         <img
//   src={
//     images.length > 0
//       ? images[currentIndex]
//       : placeholder
//   }
//   alt={ad.name}
//   className="main-image2"
//   onError={(e) => {
//     e.target.src = placeholder;
//   }}
// />
<img
  src={
    images.length > 0
      ? images[currentIndex]?.url
      : placeholder
  }
  alt={ad.name}
  className="main-image2"
  onError={(e) => {
    e.target.src = placeholder;
  }}
/>

          ) : (
            <div className="main-image2 d-flex align-items-center justify-content-center">
              لا توجد صورة
            </div>
          )}
        </div>

        {/* ===== INFO ===== */}
        <div className="product-info ">
          <div className="dtitle-rating-row">
            <h2 className="dproduct-title">{ad.name}</h2>
            <div className="drating-row">
              {/* <img src={rating} alt="star" /> */}
              {/* <span className="drate-number">{ad.avg_rate?.toFixed(1) || 0}</span> */}
            </div>
          </div>
        
          <div className="row">

        <div className="col-md-6">
          <p className="product-desc2">{ad.description?.split(" ").slice(0, 3).join(" ")}...
       
        </p>

          </div>
   <div className="col-md-6">
    {/* <img src={rating} alt="star" /> */}
         <span className="drate-number">{ad.avg_rate?.toFixed(1) || 0}</span>
    <i className="fa fa-star staricon p-2" ></i>
     
          </div>
          </div>
          <div className="dprice-row">
            <span className="dcurrent-price">
              {ad.priceAfterDiscount} {ad.currency_type}
            </span>
            <span className="dold-price">
              {ad.price} {ad.currency_type}
            </span>
            <span className="ddiscount">{ad.discount}%</span>
          </div>
        </div>
      </div>

      {/* ===== SHIPPING / INSTALLMENT ===== */}
      <div className="big-cart d-flex align-items-center">
        <div className="first-cart">
          <img src={international} alt="" />
          <span className="text-white d-block">
            {ad.delivery_type === "internal" ? "شحن داخلي" : "شحن دولي"}
          </span>
        </div>

        {/* {ad.is_installment === 1 && ( */}
        <div className="second-cart">
  <img src={installement} alt="installment" />
  <span className="text-white d-block">
    {Number(ad?.is_installment) === 1 ? "متاح تقسيط" : "لا يوجد تقسيط"}
  </span>
</div>
        {/* )} */}
      </div>

      {/* ===== STORE CARD ===== */}
      <div className="product-bottom-box mt-5 mb-5">
        <div className="seller-box mt-4">
          <div className="seller-info-wrap">
            {/* <img
              src={ad.store_image || "/placeholder.jpg"}
              className="seller-img"
              alt="seller"
            /> */}
            
            {/* <div className="d-flex flex-column w-100">
              <div className="seller-info mb-2">
                <h4 className="seller-name">{ad.store_name || "المتجر"}</h4>
                <div className="share-icons socialicons2">
                  {ad.linkFacebook && <img src={facebook} alt="facebook" />}
                  {ad.linkWhatsapp && <img src={whatsapp} alt="whatsapp" />}
                  {ad.linkInsta && <img src={insta} alt="instagram" />}
                </div>
              </div>
              <p className="seller-location text-end">الحالة: {ad.status}</p>
            </div> */}
          </div>
        </div>

        {/* <hr className="divider" /> */}

        {/* ===== STAR RATING ===== */}
        <h3 className="rate-title">تقييمك للمنتج</h3>
        {/* <div className="stars">
          {[1, 2, 3, 4, 5].map((i) => (
            <img
              key={i}
              src={productrating}
              style={{
                opacity: userRate >= i ? 1 : 0.3,
                cursor: "pointer",
                marginRight: 5,
              }}
              onClick={() => handleRate(i)}
              alt={`${i} stars`}
            />
          ))}
        </div> */}
<div className="stars">
  {[1, 2, 3, 4, 5].map((star) => (
    <span
      key={star}
      onClick={() => handleRate(star)}
      className={userRate >= star ? "active-star" : ""}
      style={{
        fontSize: "28px",
        cursor: "pointer",
        margin: "0 6px",
        color: userRate >= star ? "#ffb300" : "#ccc",
        transition: "0.2s",
      }}
    >
      ★
    </span>
  ))}
</div>

        {/* <p className="text-muted small mt-2">
          إجمالي التقييمات: {ad.total_rate || 0}
        </p> */}
      </div>
    </div>
  );
}
